import React, { useState, useEffect, useRef } from "react";
import { AppBar, Toolbar, Box, Typography, Button, Drawer, IconButton, List, ListItem, ListItemText, useMediaQuery, Menu, MenuItem, Collapse, Avatar, Divider, Alert } from "@mui/material";
import { useNavigate , useLocation } from "react-router-dom";
import { Menu as MenuIcon, Close as CloseIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon, ExitToApp as ExitToAppIcon, Paid as PaidIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import Auth from "../Auth/Auth";
import LoginPopup from "../Login/LoginPopup";
import CommonDialog from "../CommonDialog/CommonDialog";

const Header = ({open, isEditorOpen}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const empName = localStorage.getItem('employeeName') || '';
    const theme = useTheme();
    const { isLoggedIn } = Auth();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    // const [mobileOpen, setMobileOpen] = useState(false);
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [avatarMenuEl, setAvatarMenuEl] = useState(null);
    const [popupOpen, setpopupOpen] = useState(false); 
    const [activePath, setActivePath] = useState(location.pathname);
    const [unsavedDialogOpen, setUnsavedDialogOpen] = useState(false);
    const [pendingNavigationPath, setPendingNavigationPath] = useState(null);
    const prevPathRef = useRef(null);

    useEffect(() => {
        setActivePath(location.pathname);
        prevPathRef.current = location.pathname; //setting prev ref path to identify previous menu. this is required to handle schematic save changes.
    }, [location.pathname]);

    // const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

    if(location.pathname == '/stick')
    {
        return;
    }
    const publicMenu = [
        { label: "Home", path: "/" },
        // { label: "Learn", path: "/learn" },
        { label: "Features", path: "/features" },
        { label: "Pricing", path: "/subscribe" },
    ];

    const authMenu = [
        { label: "Home", path: "/" },
        { label: "Library Manager", path: "/libraryManager" },
        { label: "Schematic  Editor", path: "/schematicEditor" },
    ]

    // const filteredPublicMenu = publicMenu.filter(item => item.label !== "Pricing");
    const activeMenu = isLoggedIn ? authMenu : publicMenu;

    const handleCloseMenu = () => setAnchorEl(null);
    const handleHomeClick = (event) => {
        if (isLoggedIn) {
            setAnchorEl(event.currentTarget);
        } else {
            navigateOnTopMenuClick("/");
        }
    };


    const handleMobileMenuClick = (menuItem) => {
        navigateOnTopMenuClick(menuItem.path);
        setDrawerOpen(false);
    }

    const handleMenuClick = (menuItem) => {
        navigateOnTopMenuClick(menuItem.path);
        handleCloseMenu();
    }

    const handleAvatarClick = (event) => setAvatarMenuEl(event.currentTarget);
    const handleAvatarClose = () => setAvatarMenuEl(null);
    const handleLogout = () => {
        // localStorage.removeItem("access_token");
        // localStorage.removeItem("refresh_token");
    if (prevPathRef.current === "/schematicEditor" && isEditorOpen) { 
        setPendingNavigationPath("/"); //logout route path
        setUnsavedDialogOpen(true);
    } else {
        localStorage.clear();
        localStorage.setItem("logout-event", Date.now());
        handleAvatarClose();
        navigate("/");
        prevPathRef.current = location.pathname;
    }
    };
    
    const handelMysubscription = () =>{
        handleAvatarClose();
        navigateOnTopMenuClick("/mysubscription");
    }
    
    const getInitials = (name) => {
        if (name) {
            const parts = name.trim().split(" ");
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
    };

    const navigateOnTopMenuClick = (locationPath) => {
        if (prevPathRef.current === locationPath) {
            setPendingNavigationPath(locationPath);
        }
        else if (prevPathRef.current === "/schematicEditor" && isEditorOpen) {
            setPendingNavigationPath(locationPath);
            setUnsavedDialogOpen(true);
        } else {
            setActivePath(locationPath);
            navigate(locationPath);
            prevPathRef.current = location.pathname;
        }
    };

    const handleDialogCancel = () => {
        setUnsavedDialogOpen(false);
        setPendingNavigationPath(null);
        setAvatarMenuEl(null);
    };

    const handleDialogProceed = () => {
        if (pendingNavigationPath === "/") {   //logout route path
            localStorage.clear();
            localStorage.setItem("logout-event", Date.now());
            navigate("/");
        } else if (pendingNavigationPath) {
            setActivePath(pendingNavigationPath);
            navigate(pendingNavigationPath);
        }

        prevPathRef.current = location.pathname;
        setUnsavedDialogOpen(false);
        setPendingNavigationPath(null);
    };

    const appBarContent = (
            <Toolbar className="header-toolbar">
                {isMobile ? (
                    <>
                        <IconButton edge="start" color="primary" onClick={() => setDrawerOpen(true)}><MenuIcon fontSize="large" /></IconButton>
                        <Typography variant="h2" sx={{ flexGrow: 1 }} className="sniglet-font-text">PHYtool</Typography>
                        <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                            <Box sx={{ width: 250, p: 2 }}>
                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <IconButton onClick={() => setDrawerOpen(false)}><CloseIcon /></IconButton>
                                </Box>
                                <List>
                                    {activeMenu.map((item, i) =>
                                        item.label === "Home" && isLoggedIn ? (
                                            <React.Fragment key={i}>
                                                <ListItem button onClick={() => setSubmenuOpen(!submenuOpen)}>
                                                    <ListItemText primary={item.label} />
                                                    {submenuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                </ListItem>
                                                {/* subemnu */}
                                                <Collapse in={submenuOpen} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        {publicMenu.map((item, j) => (
                                                            <ListItem key={j} button sx={{ pl: 4 }} onClick={() => handleMobileMenuClick(item)} >
                                                                <ListItemText primary={item.label} />
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                </Collapse>
                                            </React.Fragment>
                                        ) : (
                                            <ListItem button key={i} onClick={() => handleMobileMenuClick(item)}>
                                                <ListItemText primary={item.label} />
                                            </ListItem>
                                        )
                                    )}
                                </List>
                            </Box>
                        </Drawer>
                        {isLoggedIn ? (
                            <>
                            <Avatar sx={{ bgcolor: "primary.main", cursor: "pointer", width: 32, height: 32 }} onClick={handleAvatarClick}>
                                {getInitials(empName)}
                            </Avatar>
                            <Menu
                                anchorEl={avatarMenuEl}
                                open={Boolean(avatarMenuEl)}
                                onClose={handleAvatarClose}
                            >
                                <Typography className="user-greeting">
                                    Hello <strong>{empName}</strong>
                                </Typography>
                                <Divider />
                                <MenuItem sx={{ fontSize: 13, color: 'primary.main' }} onClick={handelMysubscription}> <PaidIcon sx={{ fontSize: 'medium', color: 'primary.main' }} />
                                    &nbsp; My subscription
                                </MenuItem>
                                <MenuItem sx={{ fontSize: 13, color: 'primary.main' }} onClick={handleLogout}> <ExitToAppIcon sx={{ fontSize: 'medium', color: 'primary.main' }} />
                                    &nbsp; Logout
                                </MenuItem>
                            </Menu>
                            </>
                        ) : (
                            <Button variant="contained" color="primary" onClick={()=>{setpopupOpen(true)}} >Log in</Button>
                        )}
                    </>
                ) : (
                    <>
                    <Typography variant="h2" sx={{ display: { xs: 'none', sm: 'block' } }} className="sniglet-font-text">PHYtool</Typography>
                    <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center", gap: 3, alignItems: "center" }}>
                        {activeMenu.map((item, i) =>
                            item.label === "Home" && isLoggedIn ? (
                                <Box 
                                     className={`header-menu-item ${activePath === item.path ? "active" : ""}`}
                                    key={i}
                                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                    onClick={handleHomeClick}
                                >
                                    <Typography variant="h6">{item.label}</Typography>
                                    {anchorEl ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </Box>
                            ) : (
                                <Box 
                                    className={`header-menu-item ${activePath === item.path ? "active" : ""}`}
                                    key={i} 
                                    onClick={() => navigateOnTopMenuClick(item.path)} >
                                    <Typography variant="h6">{item.label}</Typography>
                                </Box>
                            )
                        )}
                    </Box>
                        {isLoggedIn ? (
                            <>
                            <Avatar sx={{ bgcolor: "primary.main", cursor: "pointer", width: 42, height: 42 }} onClick={handleAvatarClick} >
                                {getInitials(empName)}
                            </Avatar>
                            <Menu
                                anchorEl={avatarMenuEl}
                                open={Boolean(avatarMenuEl)}
                                onClose={handleAvatarClose}
                            >
                                <Typography className="user-greeting">
                                Hello <strong>{empName}</strong>
                                </Typography>
                                <Divider />
                                <MenuItem sx={{ fontSize: 13, color: 'primary.main' }} onClick={handelMysubscription}> <PaidIcon sx={{ fontSize: 'medium', color: 'primary.main' }} />
                                    &nbsp; My subscription
                                </MenuItem>
                                <MenuItem sx={{ fontSize: 13, color: 'primary.main' }} onClick={handleLogout}> <ExitToAppIcon sx={{ fontSize: 'medium', color: 'primary.main' }} />
                                    &nbsp; Logout
                                </MenuItem>
                            </Menu>
                            </>
                        ) : (
                            <Button variant="contained" color="primary" onClick={()=>{setpopupOpen(true)}}>Log in</Button>
                        )}
                    </>
                )}
                {/* Desktop Home dropdown */}
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} >
                    {publicMenu.map((subItem, i) => (
                        <MenuItem className="header-menu-item" key={i} onClick={() => handleMenuClick(subItem)} > {subItem.label} </MenuItem>
                    ))}
                </Menu>
            </Toolbar>
        );

return (
    <>
    {isHomePage ? (
        <AppBar position="sticky" elevation={0} className="header-appbar" sx={{ backgroundColor: "#ffffff", color: "#000000", px: 3 }}>
            {appBarContent}
            <LoginPopup open={popupOpen} onClose={() => setpopupOpen(false)} />
        </AppBar>
    ) : (
        <Collapse in={open}>
            <AppBar position="sticky" elevation={0} className="header-appbar" sx={{ backgroundColor: "#ffffff", color: "#000000", px: 3 }} >
                {appBarContent}
            </AppBar>
            <LoginPopup open={popupOpen} onClose={() => setpopupOpen(false)} />
        </Collapse>
        )}

        <CommonDialog open={unsavedDialogOpen} onClose={handleDialogCancel} title="Unsaved Changes">
            <Alert severity="warning" className="unsaved-alert">
                You may have unsaved changes in your editor. Changes will be lost on clicking "Ignore Changes". What would you like to do?
            </Alert>
            <>
                <Button variant="contained" onClick={handleDialogProceed} className="unsaved-dialog-button">
                    Ignore Changes
                </Button>
                <Button variant="contained" onClick={handleDialogCancel} className="unsaved-dialog-button">
                    Cancel
                </Button>
            </>
        </CommonDialog>
    </>
    );
};

export default Header;
